import { useState } from 'react';
import './style.scss';

function InformationStep() {

  return (
    <div className="information-step">
        <h2>Bra information om ansökningsprocessen</h2>
        <p>Vad kul att du vill bli medlem i Svenska Tecknare! För att bli medlem behöver du visa att du är yrkesverksam inom visuellt skapande. Det kan vara genom att:</p>

        <div className="form-info-box">
          <ul>
            <li><span>Studera på en godkänd utbildning</span></li>
            <li><span>Ha en examen från en <a target="_blank" href="/studentmedlemskap/">godkänd utbildning</a></span></li>
            <li><span>Vara anställd inom området</span></li>
            <li><span>Genom att visa arbetsprover och fakturor/underlag som visar att du arbetar professionellt som yrkesverksam visuell kreatör. Syftet med arbetsproverna är att visa att du har ditt kreativa visuella skapande som huvudsysselsättning. Observera att uppdrag från privatpersoner inte godkänns. Invalsnämnden gör en helhetsbedömning av din ansökan innan de fattar beslut om inträde in föreningen.</span></li>
          </ul>
        </div>

        <p>Inval görs vid sex tillfällen om året.</p>

        <div className="form-info-box">
          <h5>Vad kostar det?</h5>
          <ul>
            <li><span>Ordinarie medlemsavgift: 1992 kr/år eller 166 kr/mån</span></li>
            <li><span>Studentavgift: 300 kr/år eller 25 kr/månad</span></li>
            <li><span>Pensionärsavgift: 660 kr/ år eller 55 kr/mån</span></li>
          </ul>
          <p>1548 kronor av ordinarie medlemskap är avdragsgill i deklarationen om du är egenföretagare.</p>
        </div>

        <p>Vi kontaktar dig via mejl med besked om din ansökan.<br /><br />
          Vid frågor, kontakta <a href="mailto:info@svenskatecknare.se">info@svenskatecknare.se</a>.<br /><br />
          Vi ser fram emot din ansökan och tackar för ditt intresse för att bli medlem i Svenska Tecknare!</p>
    </div>
  );
}

export default InformationStep;
